// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__gkbYI","green":"Layout_green__DaI4A","headerContainer":"Layout_headerContainer__2am8O","pink":"Layout_pink__4PPAR","blue":"Layout_blue__syymD"};